module.exports = __webpack_public_path__ + "img/4_2022TerryFoxRun_MenPerformanceTShirt.b5600ab0.png";